import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Tooltip from 'flarum/common/components/Tooltip';

export default class ExperienceValuelBar extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  view() {
    const user = this.attrs.user;
    let expTotal = 0;
    let expLevel = 0;
    let userLevel = user?.userLevel();
    let levelConf = undefined;
    if(userLevel){
      levelConf = userLevel?.levelConf();
      expTotal = levelConf?.upgradeExperience();
      expLevel = userLevel?.allExperiences();
    }else{
      try{
        userLevel = user.data.attributes.userLevel
        levelConf =  user.data.attributes.levelConf
        expTotal = levelConf?.upgrade_experience;
        expLevel = userLevel?.all_experiences;
      }catch(e){
        console.log(e);
      }
    }
    const pointsText = app.forum.attribute('ianm-level-ranks.pointsText') || app.translator.trans('dl-person.forum.experiences.valueText');

    // let expComments = (user.commentCount() - user.discussionCount()) * 21,
    //   expDiscussions = user.discussionCount() * 33;

    // let expTotal = expComments + expDiscussions,
    //   expLevel = Math.floor(expTotal / 135),
    let expPercent = (expLevel / expTotal) * 100;
    return (

      <div className="new-PostUser-level">
        <div className="new-PostUser-levelText">{pointsText}</div>
        <div className="new-PostUser-text">
          <div className="new-PostUser-bar PostUser-bar--empty">
            <div className="new-PostUser-bar PostUser-bar-position" style={'width: ' + expPercent + '%;'}></div>
          </div>
          <div className="new-PostUser-levelPoints">
            <span className="new-PostUser-experiences">{expLevel}</span>
            <span className="new-PostUser-all-experiences">/{ expTotal }</span>
          </div>
        </div>
      </div>
    );
  }
}
